const STAFF_ROLES = new Set(['Admin', 'Director', 'Manager', 'Staff'])
const MANAGEMENT_ROLES = new Set(['Admin', 'Director'])

/** TEMP: open all pages/nav until real RBAC is wired. Set to false to restore checks. */
const TEMP_ALLOW_ALL = true

function hasAny(roles: string[], allowed: Set<string>): boolean {
  return roles.some((r) => allowed.has(r))
}

/** Manager, Director, or Admin may review approvals. Ignores the temporary open-access flag. */
export function canReviewApprovalsQueue(roles: string[]): boolean {
  const names = roles.map((r) => r.toLowerCase())
  return names.includes('manager') || names.includes('director') || names.includes('admin')
}

/** Director or Admin may unlock an approved item. */
export function canUnlockApproval(roles: string[]): boolean {
  const names = roles.map((r) => r.toLowerCase())
  return names.includes('director') || names.includes('admin')
}

/** Manager, Director, or Admin may review approvals. */
export function canReviewApprovals(roles: string[]): boolean {
  if (TEMP_ALLOW_ALL) return true
  return canReviewApprovalsQueue(roles)
}

/** Admin or Director — management nav / areas. */
export function canAccessManagementAreas(roles: string[]): boolean {
  if (TEMP_ALLOW_ALL) return true
  return hasAny(roles, MANAGEMENT_ROLES)
}

/** Admin only — system/finance/audit settings. */
export function canAccessAdminSettings(roles: string[]): boolean {
  if (TEMP_ALLOW_ALL) return true
  return roles.includes('Admin')
}

/** Admin, Director, or SuperAdmin — organisations settings (mutations: Admin|Director). */
export function canAccessOrganisations(roles: string[]): boolean {
  if (TEMP_ALLOW_ALL) return true
  return roles.includes('Admin') || roles.includes('Director') || roles.includes('SuperAdmin')
}

/** Any centre staff role (not Parent / Professional / SuperAdmin-only). */
export function isStaffRole(roles: string[]): boolean {
  if (TEMP_ALLOW_ALL) return true
  return hasAny(roles, STAFF_ROLES)
}

/** Admin or Director. */
export function isManagement(roles: string[]): boolean {
  if (TEMP_ALLOW_ALL) return true
  return hasAny(roles, MANAGEMENT_ROLES)
}

/**
 * Post-login landing.
 * Priority: SuperAdmin → organisations; else staff home.
 */
export function resolveLandingRoute(roles: string[]): '/' | '/settings/organizations' {
  if (roles.includes('SuperAdmin')) return '/settings/organizations'
  return '/'
}
